import React, { useState } from 'react';
import { metricKeys } from '@pulse/metrics';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { APP_ERROR_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import { tid } from '@utils/test';
import AppDimensionTable from '../AppDimensionTable';
import { DimensionTableWrapper, DimensionTitle } from '../styled';
import { TABLE_HEIGHT_MAPPING } from '../../header/Resize';

const errorMetrics = [metricKeys.AppErrors, metricKeys.AppCrashSessions];

function AppErrorDimensionWidget() {
  const selectedMetric = useSelector(selectedMetricSelector);
  if (!errorMetrics.includes(selectedMetric)) {
    return null;
  }
  return (
    <>
      {APP_ERROR_DIMENSIONS.map((options) => {
        return (
          <DimensionTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

const DimensionTableWidget: React.FC<{ header: string; dimension: string }> = (props) => {
  const { header, dimension } = props;
  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);
  const dndStyle = {
    gridRow: `span ${gridRow}`,
  };
  return (
    <DimensionTableWrapper
      id={dimension}
      style={dndStyle}
      {...tid(`dimension-table::${dimension}`)}
    >
      <DimensionTitle>{header}</DimensionTitle>
      <AppDimensionTable dimension={dimension} updateGrid={updateGrid} />
    </DimensionTableWrapper>
  );
};

export default AppErrorDimensionWidget;
